import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.jpg'


_pushScopeId("data-v-58130a0d")
const _hoisted_1 = {
  class: "navbar",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { class: "navbar-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "AQN",
    width: "160",
    height: "40"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "navbar-start" }
const _hoisted_9 = { class: "navbar-end" }
const _hoisted_10 = {
  key: 0,
  class: "navbar-item has-dropdown is-hoverable"
}
const _hoisted_11 = { class: "navbar-item" }
const _hoisted_12 = { class: "navbar-dropdown" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Profile", -1)
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Licenses", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", { class: "navbar-divider" }, null, -1)
const _hoisted_18 = { class: "icon" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Sign Out", -1)
const _hoisted_20 = {
  key: 1,
  class: "navbar-item"
}
const _hoisted_21 = { class: "buttons" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", null, "Sign Up", -1)
const _hoisted_23 = [
  _hoisted_22
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("a", {
        role: "button",
        class: _normalizeClass(["navbar-burger", { 'is-active': _ctx.isActive }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isActive = !_ctx.isActive))
      }, _hoisted_7, 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-menu", { 'is-active': _ctx.isActive }])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          class: "navbar-item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectItem('/')))
        }, "Home"),
        (_ctx.isSignedIn)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "navbar-item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectItem('/api-key')))
            }, "API Keys"))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          class: "navbar-item",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectItem('/pricing')))
        }, "Pricing"),
        _createElementVNode("a", {
          class: "navbar-item",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectItem('/documentation')))
        }, "Documentation"),
        _createElementVNode("a", {
          class: "navbar-item",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectItem('/faq')))
        }, "FAQ"),
        _createElementVNode("a", {
          class: "navbar-item",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectItem('/about-us')))
        }, "About Us"),
        _createElementVNode("a", {
          class: "navbar-item",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectItem('/contact-us')))
        }, "Contact Us")
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.isSignedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'chevron-down'] })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", {
                  class: "navbar-item",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectItem('/profile')))
                }, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user'] })
                  ]),
                  _hoisted_14
                ]),
                _createElementVNode("a", {
                  class: "navbar-item",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectItem('/licenses')))
                }, [
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'certificate'] })
                  ]),
                  _hoisted_16
                ]),
                _hoisted_17,
                _createElementVNode("a", {
                  class: "navbar-item",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
                }, [
                  _createElementVNode("span", _hoisted_18, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'sign-out-alt'] })
                  ]),
                  _hoisted_19
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("a", {
                  class: "button is-primary",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setModal('VSignUp_Eula')))
                }, _hoisted_23),
                _createElementVNode("a", {
                  class: "button is-light",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setModal('VSignIn')))
                }, "Sign In")
              ])
            ]))
      ])
    ], 2)
  ]))
}